var _defs, _rect, _circle, _circle2, _circle3, _circle4, _rect2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgSlateRings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 720,
    viewBox: "0 0 1280 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1280,
    y2: 720,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#162433"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1320"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "soft",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 720,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1044,
    cy: 98,
    r: 228,
    stroke: "#7C92AE",
    strokeWidth: 28,
    strokeOpacity: 0.42
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1044,
    cy: 98,
    r: 156,
    stroke: "#41556E",
    strokeWidth: 20,
    strokeOpacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 640,
    r: 206,
    stroke: "#6E859F",
    strokeWidth: 22,
    strokeOpacity: 0.36
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 198,
    cy: 640,
    r: 136,
    stroke: "#223347",
    strokeWidth: 18,
    strokeOpacity: 0.92
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 360,
    y: 160,
    width: 560,
    height: 400,
    rx: 40,
    fill: "#182433",
    fillOpacity: 0.46
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 640,
    cy: 360,
    rx: 250,
    ry: 182,
    fill: "#7A8FA6",
    fillOpacity: 0.18,
    filter: "url(#soft)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlateRings);
export default __webpack_public_path__ + "static/media/bg-slate-rings.f51500f8d3187a30b9d0ff2261c6ffae.svg";
export { ForwardRef as ReactComponent };